import { toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "qbe-filter-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QBEFilterDetail = _resolveComponent("QBEFilterDetail")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["qbe-filter p-m-2", { 'qbe-filter-detail-selected': _ctx.selected }]
    }, [
      _withDirectives(_createVNode("span", { class: "qbe-filter-tooltip qbe-filter-tooltip-left" }, _toDisplayString(_ctx.$t('qbe.advancedFilters.replaceTooltip')), 513), [
        [_vShow, _ctx.dropzoneLeftVisible]
      ]),
      _createVNode("div", {
        ref: 'filter-left-' + _ctx.filterId,
        class: "filter-dropzone",
        onDrop: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onDropComplete($event)), ["stop"])),
        onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
        onDragenter: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.displayDropzone('left')), ["prevent"])),
        onDragleave: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.hideDropzone('left')), ["prevent"]))
      }, null, 544),
      _createVNode("div", {
        class: "kn-draggable",
        draggable: "true",
        onDragstart: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragStart && _ctx.onDragStart(...args)), ["stop"]))
      }, [
        _createVNode(_component_QBEFilterDetail, {
          details: _ctx.node?.details,
          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.select(_ctx.node)), ["stop"]))
        }, null, 8, ["details"])
      ], 32),
      _createVNode("div", {
        ref: 'filter-right-' + _ctx.filterId,
        class: "filter-dropzone",
        onDrop: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.onDropMove($event)), ["stop"])),
        onDragover: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
        onDragenter: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.displayDropzone('right')), ["prevent"])),
        onDragleave: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.hideDropzone('right')), ["prevent"]))
      }, null, 544),
      _withDirectives(_createVNode("span", { class: "qbe-filter-tooltip qbe-filter-tooltip-right" }, _toDisplayString(_ctx.$t('qbe.advancedFilters.moveTooltip')), 513), [
        [_vShow, _ctx.dropzoneRightVisible]
      ])
    ], 2)
  ]))
}